import * as yup from 'yup';

export const validationSchema = yup.object({
  // email: yup
  //   .string()
  //   .trim('app.error.email-spaces')
  //   .email('app.error.email-invalid')
  //   .required('app.error.email-required'),
  // password: yup.string().required('app.error.password-required'),
});
